import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(en);

export async function initCountryLocales(locale: string) {
  const nav =
    typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
  const lang = nav.split(/[-_]/)[0];

  if (locale === 'en') {
    return 'en';
  }

  try {
    const localeModule = await import(
      `i18n-iso-countries/langs/${locale}.json`
    );
    countries.registerLocale(localeModule.default);

    return lang;
  } catch {
    console.warn(
      `i18n-iso-countries: locale "${lang}" not found, fallback to "en".`,
    );

    return lang;
  }
}

export default countries;
